import { Checkbox as CheckboxPrimitive } from '@base-ui/react/checkbox';

import CheckIcon from '@/assets/svg/checkbox-checked.svg?react';
import { cn } from '@/lib/utils';

export type CheckboxProps = CheckboxPrimitive.Root.Props;

const Checkbox = ({ className, indeterminate, ...props }: CheckboxProps) => {
  return (
    <CheckboxPrimitive.Root
      data-slot="checkbox"
      render={<button />}
      nativeButton
      indeterminate={indeterminate}
      className={cn(
        'peer group relative flex size-3.5 shrink-0 items-center justify-center rounded-xs border-2 border-gray-900 bg-white text-gray-900 outline-none',
        'cursor-pointer transition-colors',

        // checked
        'data-checked:border-green-600 data-checked:bg-white data-checked:text-green-600',

        // indeterminate
        'data-indeterminate:border-green-600 data-indeterminate:before:bg-green-600',
        'data-indeterminate:before:absolute data-indeterminate:before:size-1.75 data-indeterminate:before:rounded-[1px]',
        'data-indeterminate:hover:before:bg-green-500',

        // interactions
        'hover:border-green-500 hover:text-green-500',
        'focus:border-green-500 focus:bg-green-500/20 focus:text-green-500 focus:ring-5 focus:ring-green-500/20 focus:before:bg-green-500',
        'data-disabled:cursor-not-allowed data-disabled:border-gray-500! data-disabled:bg-white! data-disabled:text-gray-500! data-disabled:data-indeterminate:before:bg-gray-500!',

        // invalid
        'aria-invalid:border-red-400 aria-invalid:text-red-400',
        'aria-invalid:focus:border-red-400 aria-invalid:focus:text-red-400 aria-invalid:focus:before:bg-red-400',
        'aria-invalid:data-indeterminate:before:bg-red-400',
        'aria-invalid:focus:bg-red-400/20 aria-invalid:focus:ring-red-400/20',

        // disabled
        'group-data-[disabled=true]/field:opacity-50 disabled:cursor-not-allowed disabled:opacity-50',
        className,
      )}
      {...props}
    >
      <CheckboxPrimitive.Indicator
        data-slot="checkbox-indicator"
        className="grid place-content-center transition-none data-indeterminate:[&>svg]:hidden"
      >
        <CheckIcon />
      </CheckboxPrimitive.Indicator>
    </CheckboxPrimitive.Root>
  );
};

export default Checkbox;
